module.exports = __webpack_public_path__ + "img/happy-customer.fe99ca6a.png";